export enum TargetLabel {
  BUDGET = 'Budget',
  FRAMES = 'Frames',
  IMPRESSIONS = 'Impressions',
}
